/**
 * HelpHint — маленький «?», объясняющий термин, не тратя строки.
 *
 * Читатель — владелец бизнеса, а не специалист по Директу: «цена
 * обращения», «инцидент», «автотаргетинг» требуют пояснения по запросу.
 * Вынести их в текст значило бы удвоить длину отчёта.
 *
 * Позиционирование и обрезка — забота `Tooltip`: он рендерит пузырь
 * порталом, поэтому подсказка не режется об `overflow: clip` карточек и
 * не растягивает их полосой прокрутки.
 *
 * @format
 */

import {type ReactNode} from 'react';

import {ButtonBase} from '@mui/material';
import {styled} from '@mui/material/styles';

import {text} from 'ui/theme/typography';
import {surfaceVar} from 'ui/theme/surfaceContext';

import {Tooltip} from './Tooltip';

export interface HelpHintProps {
  /** Пояснение. Одно-два предложения — это не справка. */
  children: ReactNode;
  /** Доступное имя триггера. */
  label?: string;
}

const Trigger = styled(ButtonBase)(({theme}) => ({
  ...text('body.m'),
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 18,
  height: 18,
  flex: 'none',
  borderRadius: '50%',
  backgroundColor: surfaceVar('surface3'),
  color: surfaceVar('onSurfaceLight'),
  verticalAlign: 'middle',
  '&:hover, &:focus-visible': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

export function HelpHint({children, label = 'Пояснение'}: HelpHintProps) {
  return (
    <Tooltip content={children}>
      <Trigger aria-label={label} disableRipple>
        ?
      </Trigger>
    </Tooltip>
  );
}
